import React from "react";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import Sidebar from "../../components/UI/Sidebar";
import { Outlet } from "react-router-dom";
import AlgoliaSearch from "../../components/UI/AlgoliaSearch";
import { OperatingManualStyleProvider } from "../../contexts/OperatingManualStyleContext";

const OperationalManual = () => {
  const theme = useTheme();
  const smallerThanSmcreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <OperatingManualStyleProvider>
      <Box
        sx={{
          pl: 0,
          pr: 2,
        }}
      >
        <Grid container spacing={2} sx={{ padding: "0", margin: "0" }}>
          {/* Left side content */}
          {!smallerThanSmcreen && (
            <Grid
              item
              sm={5}
              md={4}
              lg={3}
              // px={2}
              sx={{
                bgcolor: "#F7F7F7",
                position: "sticky",
                top: "0px",
                height: "100vh",
                overflowY: "auto",
                alignItems: "center",
                justifyContent: "center",
                padding: 2,
              }}
            >
              <Box sx={{ mb: 2 }}>
                <AlgoliaSearch />
              </Box>
              <Sidebar />
            </Grid>
          )}

          {/* Right side content */}
          <Grid
            item
            xs={12}
            sm={7}
            md={8}
            lg={9}
            pr={!smallerThanSmcreen ? 10 : 4}
          >
            <Outlet />
          </Grid>
        </Grid>
      </Box>
    </OperatingManualStyleProvider>
  );
};

export default OperationalManual;
